import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://swap.udin.dev/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    href: '/swap',
  },
]

export default config
